import ClientNotes from 'screens/Client/Notes/ClientNotes'
import PersonalDetails from 'screens/Client/PersonalDetails'
import RequestsHistory from 'screens/Client/RequestsHistory'

export const tabs = {
    client: {
        keys: ['personalDetails', 'requestsHistory', 'notes'],
        content: {
            personalDetails: PersonalDetails,
            requestsHistory: RequestsHistory,
            notes: ClientNotes,
        },
    },
}
